/** Absolute site origin without a trailing slash, for canonical/hreflang hrefs. */
export const useSiteBaseUrl = (): string => {
	const requestURL = useRequestURL();
	const runtimeConfig = useRuntimeConfig();
	const siteConfig = useNuxtApp().$nuxtSiteConfig;
	const site = siteConfig?.get
		? siteConfig.get({ resolveRefs: true })
		: { name: "", url: "" };

	return String(
		(typeof site?.url === "string" && site.url) ||
			runtimeConfig.public.siteUrl ||
			requestURL.origin ||
			""
	).replace(/\/+$/, "");
};
